module.exports = __webpack_public_path__ + "img/198f1a8e70fc3c26606dea5d8265aace.96170181.jpg";